import { ForkKnife, Flask, House, Brain, ChartLineUp, DotsThreeOutline } from "@phosphor-icons/react";
import { T } from "../themes";

export default function BottomNav({ screen, setScreen, hasTargets }) {
  const tabs = [
    { id:"my-meals",     label:"My Meals",  icon:"ForkKnife",       float:false },
    { id:"supplements",  label:"Supps",     icon:"Flask",           float:false },
    { id:"dashboard",    label:"Today",     icon:"House",           float:"orange" },
    { id:"intelligence", label:"Intel",     icon:"Brain",           float:"teal" },
    { id:"progress",     label:"Progress",  icon:"ChartLineUp",    float:false },
    { id:"settings",     label:"More",      icon:"DotsThreeOutline",float:false, noGuard:true },
  ];
  const ICON_MAP = { ForkKnife, Flask, House, Brain, ChartLineUp, DotsThreeOutline };
  return (
    <div style={{
      position:"fixed",bottom:0,left:0,right:0,
      background:T.card,
      borderTop:`1px solid ${T.surface}`,
      padding:"10px 8px 16px",
      display:"flex",alignItems:"flex-end",
      justifyContent:"space-around",
      zIndex:1000,
    }}>
      {tabs.map(({id,label,icon,float,noGuard})=>{
        const active = screen===id;
        const enabled = noGuard || hasTargets;
        const Icon = ICON_MAP[icon];
        const floatColor = float==="orange"?T.orange:float==="teal"?T.accent:null;

        if (float) {
          return (
            <div key={id}
              onClick={()=>enabled&&setScreen(id)}
              style={{
                display:"flex",flexDirection:"column",
                alignItems:"center",gap:4,
                marginTop:-20,cursor:enabled?"pointer":"not-allowed",
                marginRight:float==="orange"?-6:0,
                marginLeft:float==="teal"?-6:0,
              }}>
              <div style={{
                width:58,height:58,borderRadius:"50%",
                background:floatColor,
                display:"flex",alignItems:"center",justifyContent:"center",
                border:`3px solid ${T.card}`,
                boxShadow:`0 6px 20px ${floatColor}55`,
              }}>
                <Icon size={26} weight="fill" color="#fff"/>
              </div>
              <span style={{fontSize:11,fontWeight:800,color:floatColor,fontFamily:T.fontSans,letterSpacing:"0.3px"}}>{label}</span>
            </div>
          );
        }

        return (
          <div key={id}
            onClick={()=>enabled&&setScreen(id)}
            style={{
              display:"flex",flexDirection:"column",
              alignItems:"center",gap:4,
              minWidth:44,cursor:enabled?"pointer":"not-allowed",
            }}>
            <div style={{
              width:40,height:40,
              display:"flex",alignItems:"center",justifyContent:"center",
            }}>
              <Icon size={22} weight="bold" color={active?T.primary:T.inkMuted}/>
            </div>
            <span style={{fontSize:11,fontWeight:active?700:500,color:active?T.primary:T.inkMuted,fontFamily:T.fontSans,letterSpacing:"0.3px"}}>{label}</span>
          </div>
        );
      })}
    </div>
  );
}
